var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2108_388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8438 13.1562C72.4415 13.1563 84.5233 18.1607 93.4313 27.0687C102.339 35.9767 107.344 48.0585 107.344 60.6563C107.344 73.254 102.339 85.3359 93.4313 94.2438C84.5233 103.152 72.4415 108.156 59.8438 108.156C47.246 108.156 35.1642 103.152 26.2562 94.2438C17.3482 85.3359 12.3438 73.254 12.3438 60.6563C12.3438 48.0585 17.3482 35.9767 26.2562 27.0687C35.1642 18.1607 47.246 13.1563 59.8438 13.1562Z",
    fill: "url(#paint0_radial_2108_388)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8438 15.5563C47.8826 15.5563 36.4112 20.3079 27.9533 28.7658C19.4954 37.2237 14.7438 48.6951 14.7438 60.6564C14.7438 72.6176 19.4954 84.089 27.9533 92.5469C36.4112 101.005 47.8826 105.756 59.8438 105.756C71.8051 105.756 83.2765 101.005 91.7344 92.5469C100.192 84.089 104.944 72.6176 104.944 60.6564C104.944 48.6951 100.192 37.2237 91.7344 28.7658C83.2765 20.3079 71.8051 15.5563 59.8438 15.5563ZM24.5592 25.3717C33.9173 16.0137 46.6095 10.7563 59.8438 10.7563C73.0781 10.7563 85.7704 16.0137 95.1285 25.3717C104.487 34.7298 109.744 47.422 109.744 60.6564C109.744 73.8907 104.487 86.5829 95.1285 95.941C85.7704 105.299 73.0781 110.556 59.8438 110.556C46.6095 110.556 33.9173 105.299 24.5592 95.941C15.2012 86.5829 9.94385 73.8907 9.94385 60.6564C9.94385 47.4221 15.2012 34.7298 24.5592 25.3717Z",
    fill: "url(#paint1_radial_2108_388)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6972 40.803C80.6344 41.7403 80.6344 43.2599 79.6972 44.1972L43.6972 80.1972C42.7599 81.1344 41.2403 81.1344 40.303 80.1972C39.3658 79.2599 39.3658 77.7403 40.303 76.803L76.303 40.803C77.2403 39.8658 78.7599 39.8658 79.6972 40.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.303 40.803C41.2403 39.8658 42.7599 39.8658 43.6972 40.803L79.6972 76.803C80.6344 77.7403 80.6344 79.2599 79.6972 80.1972C78.7599 81.1344 77.2403 81.1344 76.303 80.1972L40.303 44.1972C39.3658 43.2599 39.3658 41.7403 40.303 40.803Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2108_388",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.189 133.046) rotate(-134.873) scale(196.79 669.438)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2108_388",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.794 136.704) rotate(-134.873) scale(206.733 703.263)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2108_388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.ae85818031e1452c1a9432db2407851b.svg";
export { ForwardRef as ReactComponent };